//  @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import ListGroup from '../../Components/ListGroup';
import Heading from '../../Components/Heading';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

import Image1_png from '../../Assets/v2/home/work1.1.png';
import Image2_png from '../../Assets/v2/home/work1.2.png';
import Image3_png from '../../Assets/v2/home/work1.3.png';
import Image4_png from '../../Assets/v2/home/work1.4.png';

import Image1_webp from '../../Assets/v2/home/work1.1.webp';
import Image2_webp from '../../Assets/v2/home/work1.2.webp';
import Image3_webp from '../../Assets/v2/home/work1.3.webp';
import Image4_webp from '../../Assets/v2/home/work1.4.webp';

import Image1_fallback from '../../Assets/fallbacks/home/work1.1.jpg';
import Image2_fallback from '../../Assets/fallbacks/home/work1.2.jpg';
import Image3_fallback from '../../Assets/fallbacks/home/work1.3.jpg';
import Image4_fallback from '../../Assets/fallbacks/home/work1.4.jpg';

const WorkRow = props => (
  <div className={`work-row-item ${props.className}`}>
    <ImageBlurFallback
      fallbackImage={props.fallbackImage}
      className="work-row-img"
      webpImage={props.webpImage}
      src={props.image}
      alt={props.alt}
    />
    <p className="work-row-text">{props.text}</p>
  </div>
);

const WorkArea = () => {
  const { t } = useTranslation();
  return (
    <ListGroup
      center
      title={<Heading title={t('workareaHeading')} />}
      containerClassName="we-work-container"
      titleClassName=""
      descriptionClassName="we-work-container-description"
      count={4}>
      <WorkRow
        fallbackImage={Image1_fallback}
        webpImage={Image1_webp}
        image={Image1_png}
        alt={t('img1-alt')}
        text={t('workareaimg1desc')}
      />
      <WorkRow
        fallbackImage={Image2_fallback}
        webpImage={Image2_webp}
        image={Image2_png}
        alt={t('img2-alt')}
        text={t('workareaimg2desc')}
      />
      <WorkRow
        fallbackImage={Image3_fallback}
        webpImage={Image3_webp}
        image={Image3_png}
        alt={t('img3-alt')}
        text={t('workareaimg3desc')}
      />
      <WorkRow
        fallbackImage={Image4_fallback}
        webpImage={Image4_webp}
        image={Image4_png}
        alt={t('img4-alt')}
        text={t('workareaimg4desc')}
      />
    </ListGroup>
  );
};

export default WorkArea;



// WEBPACK FOOTER //
// ./src/Pages/Home/WorkArea.js